export default __webpack_public_path__ + "static/media/Rates.de71a95a.png";